import { State } from "./State";
export class AllowedGames {
    constructor(types) {
        this.bingo90 = new State(false);
        this.bingo75 = new State(false);
        this.bingoMex = new State(false);
        this.bingoAnimals = new State(false);
        this.bingoCartoon = new State(false);
        this.movies = new State(false);
        this.moviesKids = new State(false);
        this.xmas = new State(false);
        this.football = new State(false);
        this.halloween = new State(false);
        this.superheroes = new State(false);
        this.cartoon = new State(false);
        this.music = new State(false);
        this.canary = new State(false);
        this.musicReggaeton = new State(false);
        this.bingoDominicano = new State(false);
        this.bingoIberostar = new State(false);
        this.musicWinterEnglish = new State(false);
        this.musicWinterSpanglish = new State(false);
        this.bingoGloriaMusicos = new State(false);
        this.bingoGloriaLuchadores = new State(false);
        this.bingoGloriaChavo = new State(false);
        this.bingoGloriaActors = new State(false);
        this.calamarGame = new State(false);
        this.calamarIcons = new State(false);
        this.squidGames = new State(false);
        this.bingoFifa26 = new State(false);
        this.bingoJugadoresFifa26 = new State(false);
        this.bingo90.set(types.includes('Bingo90'));
        this.bingo75.set(types.includes('Bingo75'));
        this.bingoMex.set(types.includes('BingoMex'));
        this.bingoAnimals.set(types.includes('BingoAnimals'));
        this.bingoCartoon.set(types.includes('BingoCartoon'));
        this.movies.set(types.includes('Movies'));
        this.moviesKids.set(types.includes('MoviesKids'));
        this.xmas.set(types.includes('XMas'));
        this.football.set(types.includes('Football'));
        this.halloween.set(types.includes('Halloween'));
        this.superheroes.set(types.includes('Superheroes'));
        this.cartoon.set(types.includes('Cartoon'));
        this.music.set(types.includes('Music'));
        this.canary.set(types.includes('Canary'));
        this.musicReggaeton.set(types.includes('MusicReggaeton'));
        this.bingoDominicano.set(types.includes('BingoDominicano'));
        this.bingoIberostar.set(types.includes('BingoIberostar'));
        this.musicWinterEnglish.set(types.includes('MusicWinterEnglish'));
        this.musicWinterSpanglish.set(types.includes('MusicWinterSpanglish'));
        this.bingoGloriaMusicos.set(types.includes('BingoGloriaMusicos'));
        this.bingoGloriaLuchadores.set(types.includes('BingoGloriaLuchadores'));
        this.bingoGloriaChavo.set(types.includes('BingoGloriaChavo'));
        this.bingoGloriaActors.set(types.includes('BingoGloriaActors'));
        this.calamarGame.set(types.includes('CalamarGame'));
        this.calamarIcons.set(types.includes('CalamarIcons'));
        this.squidGames.set(types.includes('SquidGames'));
        this.bingoFifa26.set(types.includes('BingoFifa26'));
        this.bingoJugadoresFifa26.set(types.includes('BingoJugadoresFifa26'));
    }
    toJSON() {
        const types = [];
        if (this.bingo90.value)
            types.push('Bingo90');
        if (this.bingo75.value)
            types.push('Bingo75');
        if (this.bingoMex.value)
            types.push('BingoMex');
        if (this.bingoAnimals.value)
            types.push('BingoAnimals');
        if (this.bingoCartoon.value)
            types.push('BingoCartoon');
        if (this.movies.value)
            types.push('Movies');
        if (this.moviesKids.value)
            types.push('MoviesKids');
        if (this.xmas.value)
            types.push('XMas');
        if (this.football.value)
            types.push('Football');
        if (this.halloween.value)
            types.push('Halloween');
        if (this.superheroes.value)
            types.push('Superheroes');
        if (this.cartoon.value)
            types.push('Cartoon');
        if (this.music.value)
            types.push('Music');
        if (this.canary.value)
            types.push('Canary');
        if (this.musicReggaeton.value)
            types.push('MusicReggaeton');
        if (this.bingoDominicano.value)
            types.push('BingoDominicano');
        if (this.bingoIberostar.value)
            types.push('BingoIberostar');
        if (this.musicWinterEnglish.value)
            types.push('MusicWinterEnglish');
        if (this.musicWinterSpanglish.value)
            types.push('MusicWinterSpanglish');
        if (this.bingoGloriaMusicos.value)
            types.push('BingoGloriaMusicos');
        if (this.bingoGloriaLuchadores.value)
            types.push('BingoGloriaLuchadores');
        if (this.bingoGloriaChavo.value)
            types.push('BingoGloriaChavo');
        if (this.bingoGloriaActors.value)
            types.push('BingoGloriaActors');
        if (this.calamarGame.value)
            types.push('CalamarGame');
        if (this.calamarIcons.value)
            types.push('CalamarIcons');
        if (this.squidGames.value)
            types.push('SquidGames');
        if (this.bingoFifa26.value)
            types.push('BingoFifa26');
        if (this.bingoJugadoresFifa26.value)
            types.push('BingoJugadoresFifa26');
        return types;
    }
}
